import { ListMethodArg, ListMethodResponse } from '/imports/types';
import { SolarBill } from '/imports/api/solarBills';
import { DeclareMethod } from '/imports/methods';

export interface CalpineBillingParams { batch: number, startDate: string, endDate: string }
export const generateCalpineBills = DeclareMethod<CalpineBillingParams, number>('generateCalpineBills');
interface CalpineSendBillsParams { billIds: string[], subject: string, html: string, ccEmails?: string, test?: boolean }
export const sendCalpineBills = DeclareMethod<CalpineSendBillsParams, number>('sendCalpineBills');
export const getCalpineXlsxUrl = DeclareMethod<{ xlsxPath: string, expiresIn?: number }, string>('getCalpineXlsxUrl');
export const listCalpineBills = DeclareMethod<ListMethodArg<SolarBill>, ListMethodResponse<SolarBill>>('listCalpineBills');
